import UploadDataButton from "@Layouts/components/Buttons/UploadDataButton";
import { ChangeEvent } from "react";

interface IUploadDataButtonWrapperProps {
	isUpdatable: boolean;
	canUpload: boolean;
	ingesting: boolean;
	handleUploadFile: (event: ChangeEvent<HTMLInputElement>) => void;
}

const UploadDataButtonWrapper = ({ isUpdatable, canUpload, ingesting, handleUploadFile }: IUploadDataButtonWrapperProps) => (
	<>
		{isUpdatable && (
			<UploadDataButton
				title="Upload Report"
				className={
					"!shadow-none !bg-primary hover:!shadow-big hover:!shadow-primary !rounded-md [&.Mui-disabled]:!bg-disabled [&.Mui-disabled]:!text-white !px-[18px] !py-[6px] min-w-[120px]\
          [&_.MuiTypography-root]:!font-sans [&_.MuiTypography-root]:!font-normal [&_.MuiTypography-root]:!text-sm/[normal] z-10"
				}
				accept=".csv"
				disabled={!canUpload}
				uploading={ingesting}
				onChange={handleUploadFile}
			/>
		)}
	</>
);

export default UploadDataButtonWrapper;
